import React from 'react';
import {inject, observer} from 'mobx-react';
import Avatar from '../Avatar/index';
import styles from './style.css';

const AgentPreview = inject('store')(observer(
    function AgentPreview({agentId, store, onClick, selected = false}) {
        const agent = store.getAgent(agentId)
        return (
                <div className={selected ? styles.selectedAgent : styles.agent} onClick={onClick}>
                    {agent.avatar && <Avatar avatar={agent.avatar} size={45} borderWidth={1} />}
                    <span className={styles.name}>{agent.email}</span>
            </div>
        )
}))

export default AgentPreview;


// WEBPACK FOOTER //
// ./src/components/AgentsList/AgentPreview.js